export default __webpack_public_path__ + "static/media/050_brake.vp8.fe1e8e32.webm";